// extracted by mini-css-extract-plugin
export default {"root":"MobileHomePage__root--29jUF","root_error":"MobileHomePage__root_error--muUI7","content":"MobileHomePage__content--3s9nu"};